import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import _styled from "styled-components";
import _throttle2 from "lodash/throttle";
import * as React from 'react';
import classnames from 'classnames';
import { Analytics, AnalyticsContext, AnalyticsLocationProvider, trackEvent } from 'latitude-analytics';
import SvgInline from '@latitude/svg-inline';
import { Link } from '@latitude/link';
import { ANALYTICS, BUTTON_STYLE, BREAKPOINT } from '@latitude/core/utils/constants';
import './_sticky-navigation.scss';
let StickyNavigation = /*#__PURE__*/function (_React$Component) {
  function StickyNavigation(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.scrollHandler = _throttle2(() => {
      if (_this.stickyNavElem.current == null) {
        return;
      }
      const isActive = window.pageYOffset > _this.getTriggerPosition();
      _this.setState({
        active: isActive,
        offset: isActive ? _this.getOffsetPosition() : 0,
        placeholderHeight: isActive ? _this.getPlaceholderHeight() : 0
      });
    }, 1);
    _this.stickyNavElem = /*#__PURE__*/React.createRef();
    _this.placeholderElem = /*#__PURE__*/React.createRef();
    _this.state = {};
    return _this;
  }
  _inheritsLoose(StickyNavigation, _React$Component);
  var _proto = StickyNavigation.prototype;
  _proto.componentDidMount = function componentDidMount() {
    document.addEventListener('scroll', this.scrollHandler);
  }

  // Trigger - When the sticky will be triggered
  ;
  _proto.getTriggerPosition = function getTriggerPosition() {
    const triggerElem = document.querySelector(this.props.triggerElem || '[data-sticky-navigation-placeholder]');
    if (triggerElem === null) {
      return 0;
    }
    return triggerElem.getBoundingClientRect().top + window.pageYOffset - this.getOffsetPosition();
  }

  // Placeholder height - work out what the height should be of the placeholder
  ;
  _proto.getPlaceholderHeight = function getPlaceholderHeight() {
    return this.stickyNavElem && this.stickyNavElem.current ? this.stickyNavElem.current.offsetHeight || 0 : 0;
  }

  // Offset - how far from the top to position the stickynav when active
  ;
  _proto.getOffsetPosition = function getOffsetPosition() {
    let offsetElem = null;
    if (this.props.offsetElem) {
      offsetElem = document.querySelector(this.props.offsetElem);
    }
    return offsetElem ? offsetElem.offsetHeight || 0 : 0;
  };
  _proto.componentWilllUnMount = function componentWilllUnMount() {
    document.removeEventListener('scroll', this.scrollHandler);
  }

  // Handle click - nav item
  ;
  _proto.handleClickNavItem = function handleClickNavItem(item, analytics) {
    const {
      anchor
    } = item;
    const anchorElem = document.querySelector(`#${anchor}`);
    if (anchorElem) {
      window.scrollTo({
        top: anchorElem.getBoundingClientRect().top + window.pageYOffset - this.getOffsetPosition() - this.getPlaceholderHeight(),
        behavior: 'smooth'
      });
    } else {
      // eslint-disable-next-line no-console
      console.log('warning - sticky-nav - destination doesnt exist');
    }
    if (this.props.clickEventCallback) {
      this.props.clickEventCallback(item);
    } else {
      trackEvent(analytics, {
        category: 'navigation',
        action: 'in-page-navigation',
        label: item.label,
        location: 'menu-nav'
      });
    }
  };
  _proto.render = function render() {
    var _this$props;
    const NavItems = props => /*#__PURE__*/React.createElement(AnalyticsContext.Consumer, null, _ref => {
      let [analytics] = _ref;
      return /*#__PURE__*/React.createElement("ul", {
        className: `sticky-navigation__nav-items ${props.className || ''}`
      }, props.items.map((item, i) => /*#__PURE__*/React.createElement("li", {
        className: "sticky-navigation__nav-item",
        key: i
      }, /*#__PURE__*/React.createElement(Link, {
        noStyle: true,
        className: "sticky-navigation__nav-link",
        trackId: `sticky-navigation-nav-link--${item.anchor}`,
        href: `#${item.anchor}`,
        disableDefaultEventTracking: true,
        onClick: e => {
          e.preventDefault();
          this.handleClickNavItem(item, analytics);
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: "arrow"
      }), /*#__PURE__*/React.createElement("span", {
        className: "label"
      }, item.label)))));
    });
    const PhoneNumber = props => /*#__PURE__*/React.createElement(Link, {
      noStyle: true,
      className: "sticky-navigation__phone",
      trackId: "sticky-navigation-phone",
      href: `tel:${props.phoneNumber}`,
      trackEventData: {
        label: `${props.phoneNumber}`
      }
    }, /*#__PURE__*/React.createElement(SvgInline, {
      strokeBlueBright: true,
      className: "sticky-navigation__phone-icon",
      name: "phone"
    }), /*#__PURE__*/React.createElement("span", {
      className: "sticky-navigation__phone-number"
    }, props.phoneNumber));
    const Cta = props => /*#__PURE__*/React.createElement(Link, {
      target: props.ctaTarget,
      button: props.button,
      className: "sticky-navigation__cta",
      href: props.href,
      trackId: props.trackId || 'sticky-navigation-apply',
      trackEventData: props.trackEventData,
      onClick: props.ctaOnClick
    }, props.ctaText);
    return /*#__PURE__*/React.createElement(_StyledDiv, {
      $_css: this.props.isVisible ? 'block' : 'none',
      $_css2: BREAKPOINT.LG
    }, /*#__PURE__*/React.createElement("div", {
      ref: this.placeholderElem,
      "data-sticky-navigation-placeholder": true,
      className: "sticky-navigation-placeholder",
      style: {
        height: this.state.placeholderHeight
      }
    }), /*#__PURE__*/React.createElement("nav", {
      ref: this.stickyNavElem,
      className: classnames(`sticky-navigation`, this.state.active && 'sticky-navigation--fixed', this.props.noShadow && 'sticky-navigation--no-shadow', this.props.className),
      style: {
        transform: `translateY(${this.state.offset || 0}px)`
      },
      "data-contentful": (_this$props = this.props) === null || _this$props === void 0 ? void 0 : _this$props.contentfulID
    }, this.props.children ? this.props.children : /*#__PURE__*/React.createElement("div", {
      className: "sticky-navigation__inner"
    }, /*#__PURE__*/React.createElement(NavItems, {
      items: this.props.items || []
    }), /*#__PURE__*/React.createElement(AnalyticsLocationProvider, {
      location: ANALYTICS.LOCATION.STICKY_CTA
    }, /*#__PURE__*/React.createElement("div", {
      className: "sticky-navigation__cta-group"
    }, this.props.phoneNumber && /*#__PURE__*/React.createElement(PhoneNumber, {
      phoneNumber: this.props.phoneNumber
    }), this.props.ctaHref && /*#__PURE__*/React.createElement(Cta, {
      button: this.props.ctaType || BUTTON_STYLE.PRIMARY,
      href: this.props.ctaHref,
      ctaText: this.props.ctaText || 'Apply Now',
      ctaTarget: this.props.ctaTarget,
      ctaOnClick: this.props.ctaOnClick,
      trackEventData: this.props.trackEventData,
      trackId: this.props.trackId
    }))))));
  };
  return StickyNavigation;
}(React.Component);
export default StickyNavigation;
var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "StickyNavigation___StyledDiv",
  componentId: "sc-1dtsv93-0"
})(["position:relative;z-index:10;display:", ";@media (min-width:", "){display:block;}"], p => p.$_css, p => p.$_css2);